var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.clone
    ? _c("div", { staticClass: "block-editor ai-bot-response payload" }, [
        _c(
          "div",
          { staticClass: "ready-templates" },
          [
            !_vm.showTemplates
              ? _c(
                  "span",
                  {
                    staticClass: "btnImport",
                    on: {
                      click: function ($event) {
                        _vm.showTemplates = true
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("message.importFromReadyTemplates")))]
                )
              : _c(
                  "a-select",
                  {
                    staticStyle: { width: "300px" },
                    attrs: {
                      placeholder: _vm.$t("message.selectTemplate"),
                      autofocus: true,
                      "default-open": true,
                    },
                    on: { change: _vm.injectTemplate },
                  },
                  _vm._l(_vm.templates, function (template) {
                    return _c(
                      "a-select-option",
                      { key: template.slug, attrs: { value: template.slug } },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              _vm.selectedLanguage === "tr"
                                ? template.name.tr
                                : template.name.en
                            ) +
                            "\n            "
                        ),
                      ]
                    )
                  }),
                  1
                ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "says" },
          [
            _c("TiptapEditor", {
              key: "tiptap-prompt" + _vm.renderKey,
              attrs: {
                "show-emoji": true,
                "show-attributes": true,
                placeholder: _vm.$t("message.botScenerio"),
                "max-character-count": 6200,
              },
              model: {
                value: _vm.clone.prompt,
                callback: function ($$v) {
                  _vm.$set(_vm.clone, "prompt", $$v)
                },
                expression: "clone.prompt",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          [
            _c("span", [_vm._v("Cevabı Attribute'a Kaydet?")]),
            _vm._v(" "),
            _c(
              "a-switch",
              {
                attrs: {
                  "checked-children": "Evet",
                  "un-checked-children": "Hayır",
                  "default-checked": false,
                },
                model: {
                  value: _vm.clone.saveAsAttribute,
                  callback: function ($$v) {
                    _vm.$set(_vm.clone, "saveAsAttribute", $$v)
                  },
                  expression: "clone.saveAsAttribute",
                },
              },
              [_vm._v("\n            Cevabı Attribute'a Kaydet\n        ")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _vm.clone.saveAsAttribute
          ? _c(
              "div",
              { staticClass: "attribute-picker-section" },
              [
                _c("span", { staticClass: "sectionTitle" }, [
                  _vm._v(
                    " " + _vm._s(_vm.$t("chatbotv2.saveResposeToAttribute"))
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "a-popover",
                  {
                    attrs: { trigger: "click", overlayClassName: "no-padding" },
                    model: {
                      value: _vm.attributePickerVisible,
                      callback: function ($$v) {
                        _vm.attributePickerVisible = $$v
                      },
                      expression: "attributePickerVisible",
                    },
                  },
                  [
                    _c(
                      "div",
                      { attrs: { slot: "content" }, slot: "content" },
                      [
                        _c("AttributePicker", {
                          attrs: {
                            "default-selected": _vm.clone.attribute,
                            pick: _vm.onAttributePicked,
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "attribute-input" }, [
                      _c(
                        "div",
                        { staticClass: "attribute-input-text-wrapper" },
                        [
                          _vm.$_.isEmpty(_vm.clone.attribute)
                            ? _c(
                                "div",
                                { staticClass: "attribute-input-placeholder" },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(
                                        _vm.$t("chatbotv2.chooseAttributeType")
                                      ) +
                                      "\n                    "
                                  ),
                                ]
                              )
                            : _c(
                                "div",
                                {
                                  staticClass: "single-attribute-style",
                                  class: { active: _vm.attributePickerVisible },
                                },
                                [
                                  _c("AttributeIconPreview", {
                                    attrs: { attribute: _vm.clone.attribute },
                                  }),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          ("" + _vm.clone.attribute).startsWith(
                                            "akinon_"
                                          ) ||
                                            (
                                              "" + _vm.clone.attribute
                                            ).startsWith("probel_") ||
                                            _vm
                                              .Attributes()
                                              .includes(_vm.clone.attribute)
                                            ? _vm.$t(
                                                "chatbotv2.attr." +
                                                  _vm.clone.attribute
                                              )
                                            : _vm.clone.attribute.startsWith(
                                                "contact_property_"
                                              )
                                            ? _vm.visitorContactAttributes[
                                                _vm.clone.attribute.replace(
                                                  "contact_property_",
                                                  ""
                                                )
                                              ]
                                            : _vm.clone.attribute
                                        ) +
                                        "\n                        "
                                    ),
                                  ]),
                                ],
                                1
                              ),
                        ]
                      ),
                      _vm._v(" "),
                      !_vm.$_.isEmpty(_vm.clone.attribute)
                        ? _c("span", { staticClass: "material-icons" }, [
                            _vm._v(" expand_more "),
                          ])
                        : _vm._e(),
                    ]),
                  ]
                ),
              ],
              1
            )
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }